/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Position_DescriptionInputs */

const en_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a caption position and apply it to selected events.`)
};

const fr_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une position de sous-titrage et appliquez-la aux événements sélectionnés.`)
};

const de_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Bildunterschriftenposition und wenden Sie sie auf ausgewählte Ereignisse an.`)
};

const it_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una posizione della didascalia e applicala agli eventi selezionati.`)
};

const ru_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите позицию подписи и примените её к выбранным событиям.`)
};

const es_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija una posición de subtítulo y aplíquela a los eventos seleccionados.`)
};

const zh_cn2_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择标题位置并将其应用于选定的活动。`)
};

const ja_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション位置を選択し、選択したイベントに適用します。`)
};

const hi_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक कैप्शन स्थिति चुनें और इसे चयनित इवेंट्स पर लागू करें।`)
};

const pt_pt2_caption_position_description = /** @type {(inputs: Caption_Position_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma posição da legenda e aplique-a aos eventos selecionados.`)
};

/**
* | output |
* | --- |
* | "Choose a caption position and apply it to selected events." |
*
* @param {Caption_Position_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position_description = /** @type {((inputs?: Caption_Position_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Position_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_position_description(inputs)
	if (locale === "de") return de_caption_position_description(inputs)
	if (locale === "it") return it_caption_position_description(inputs)
	if (locale === "ru") return ru_caption_position_description(inputs)
	if (locale === "es") return es_caption_position_description(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_position_description(inputs)
	if (locale === "ja") return ja_caption_position_description(inputs)
	if (locale === "hi") return hi_caption_position_description(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_position_description(inputs)
	return en_caption_position_description(inputs)
});